<template>
    <div class = "fullHeader">
        <img src="../../img/logo_portic_petit.png" alt="">

        <div class = "HeaderNav">
            <md-button class="md-icon-button">
                <a href = "https://anr.portic.fr/acces-visualisations/"><md-icon>home</md-icon></a>

            </md-button>

            <md-button class = "buttonHeader"><a href="flux.html">Cartographie des ports de Navigocorpus</a></md-button>
            <!-- <md-button class = "buttonHeader"><a href="aggregate.html">Aggregate </a></md-button>-->
            <md-button class = "buttonHeader"><a href="detail.html">Rechercher un capitaine/un navire</a></md-button>


        </div>


    </div>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped>


    .fullHeader
    {
        display: flex;
        background-color : white;
        height: 50px;
        width: 100%;
        border-color: #e7e7e7;
        border-width: 1px 0 5px;


    }

    .fullHeader img
    {
        width: 45px;
        height : 47px;



        margin-left: 15px;
        margin-bottom: 2px;
        margin-top: 2px;
        -moz-box-shadow: 5px 5px 10px 0px #333333;
        -webkit-box-shadow: 5px 5px 10px 0px #333333;
        -o-box-shadow: 5px 5px 10px 0px #333333;
        box-shadow: 5px 5px 10px 0px #333333;
        filter:progid:DXImageTransform.Microsoft.Shadow(color=#333333, Direction=134, Strength=10);
    }
    .HeaderNav{
        position: absolute;
        right : 0;
    }

    .HeaderNav a{
        color : #757575;

    }



    .buttonHeader{
        bottom: 4px;
    }



</style>


// WEBPACK FOOTER //
// src-detail/components/VUE/Header.vue